// The shipping-signing switches (Phases 2-4, 2026-10-28): GET /features "shipping_signing"
//   {pickup, delivery, carrier_dock, job_loads}   (jobq-api: dev ON, prod OFF until Mike flips each one)
//   pickup     Start pickup = the load-out checklist, then the customer signs on a phone (QR) or on paper
//   delivery   Ready to ship "Load truck" for delivery orders (driver, truck, checklist, signing QR on the manifest);
//              Out for delivery shows the load + signature; History lists the loads
//   job_loads  Ship by job names a pallet + truck and records the load
//   vendor_receipt  an outsourcing paper's printed copy carries a QR the vendor signs for receipt on (2026-10-29;
//              features/signing/vendorSigning.js): the Outsourcing tab / coating desk show its state + the QR
// Each one absent, false or not a boolean = exactly the Phase 1 behaviour. Read from the SAME /features request as
// the hub switch (hubFlag.fetchFeaturesBody: one request per page load); any failure reads as all off.
import { useEffect, useState } from 'react';
import { fetchFeaturesBody } from './hubFlag';

export const SIGNING_OFF = Object.freeze({
  pickup: false, delivery: false, carrier_dock: false, job_loads: false, vendor_receipt: false,
});
const KEYS = Object.keys(SIGNING_OFF);

/** GET /features body -> {pickup, delivery, carrier_dock, job_loads, vendor_receipt}, each true only when the API says true. */
export function parseShippingSigning(body) {
  const obj = body && typeof body === 'object' && !Array.isArray(body) ? body : null;
  const s = obj ? obj.shipping_signing : null;
  if (!s || typeof s !== 'object' || Array.isArray(s)) return { ...SIGNING_OFF };
  const out = {};
  KEYS.forEach((k) => { out[k] = s[k] === true; });
  return out;
}

export async function fetchShippingSigningFlags() {
  return parseShippingSigning(await fetchFeaturesBody());
}

/** {loaded, pickup, delivery, carrier_dock, job_loads}: all off until the answer lands. */
export function useShippingSigningFlags() {
  const [state, setState] = useState(() => ({ loaded: false, ...SIGNING_OFF }));
  useEffect(() => {
    let alive = true;
    fetchShippingSigningFlags().then((flags) => { if (alive) setState({ loaded: true, ...flags }); });
    return () => { alive = false; };
  }, []);
  return state;
}
